export const pendingRoommateDecisionKey = (responseId: string): string =>
  `form-builder:roommate-decision:${responseId}`;

/** Discard only the departed membership from an interrupted acceptance save. */
export function clearDepartedRoommateRecovery(responseId: string, membershipId: number): void {
  const key = pendingRoommateDecisionKey(responseId);
  try {
    const value = window.localStorage.getItem(key);
    if (!value) return;
    const block = JSON.parse(value);
    if (!Array.isArray(block?.roommates)) {
      window.localStorage.removeItem(key);
      return;
    }
    block.roommates = block.roommates.filter(
      (member: { id?: number }) => member.id !== membershipId,
    );
    if (!block.roommates.length) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, JSON.stringify(block));
  } catch {
    // Server-side departed-membership markers also protect against stale recovery writes.
  }
}
